"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_FIELD_TYPES_WITH_CUSTOM_FIELD_VALUES = exports.CustomFieldTypeName = void 0;
var CustomFieldTypeName;
(function (CustomFieldTypeName) {
    CustomFieldTypeName["singleSelect"] = "single-select";
    CustomFieldTypeName["multiSelect"] = "multi-select";
    CustomFieldTypeName["plainText"] = "plain-text";
    CustomFieldTypeName["date"] = "date";
})(CustomFieldTypeName || (exports.CustomFieldTypeName = CustomFieldTypeName = {}));
exports.CUSTOM_FIELD_TYPES_WITH_CUSTOM_FIELD_VALUES = [
    CustomFieldTypeName.singleSelect,
    CustomFieldTypeName.multiSelect,
];
//# sourceMappingURL=customFields.js.map